export default __webpack_public_path__ + "static/media/comm-ccmm.eafee519.jpeg";